import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
        const token = localStorage.getItem('auth_token');
        const authReq = token
            ? req.clone({ setHeaders: { Authorization: token } })
            : req;
      
        return next.handle(authReq).pipe(
      map((event: HttpEvent<any>) => event),
      catchError((error) => {
        if (error.status === 401) {
          sessionStorage.clear();
          localStorage.clear();
          window.location.href = '/#/auth/login';
        }
        return throwError(error);
      })
    );
  }
}
